import React, { useState } from "react";
import { Menu } from "@headlessui/react";
import config from "../../../../config";
import Modal from "../../../../CommonComponent/Modal";

export default function ListingRow(props){
    
    const { bid, auctionData, deleteBidHandler } =props;
    const [isOpen, setIsOpen] = useState(false);
    const [loading, setLoading] = useState(false);

    const content = <div className="bg-[#F4F4F5] p-2 mx-[40px] my-4" >
        <p className="text-[14px] text-[#52525A]"><span className="font-bold" >Name: </span>{bid.name}</p>
        <p className="text-[14px] text-[#52525A]" ><span className="font-bold" >Paddle Number: </span>{bid.paddle_number}</p>
        <p className="text-[14px] text-[#52525A]"><span className="font-bold" >Lot: </span>{bid.lot_number}</p>
        <p className="text-[14px] text-[#52525A]"><span className="font-bold" >Emergency Bid: </span>
            {Number(bid.bid_amount).toLocaleString(auctionData.currency ==='INR' ? 'en-IN' : 'en-US', {
                style: 'currency',
                currency: auctionData.currency,
                minimumFractionDigits: 0,
                maximumFractionDigits: 0,
            })}
        </p>
    </div>

    const deleteHandler= async()=>{
        setLoading(true);
        const response = await deleteBidHandler(bid._id)
        if(response){
            setLoading(false);
            setIsOpen(false);
        }
    }

    return(
        <>
            <tr className="border-b border-[#DEDEDE]" >
                <td className="text-[#343434]  px-5 py-3 text-[14px] leading-normal font-medium ">
                    {bid.lot_number}</td>
                <td><img id='lot_img' data-testid="lot_img"
                    src={(!bid.lot_image || bid.lot_image==="") ? "/images/img-lotlist.png" : 
                        `${config.Storage.CDN}${bid.lot_image}`}
                    className="my-3 w-[95px] h-[77px]" alt="img"/></td>
                <td className="text-[#343434] px-4 py-3 text-[14px]  leading-normal font-medium" >
                    {bid.lot_title.length > 20 ? bid.lot_title.substring(0, 20) + '...' : bid.lot_title}</td>
                <td className=" text-[#343434] px-5 py-3 text-[14px]  leading-normal font-medium truncate max-w-[170px]"
                    title={(bid.reserve===0 || bid.reserve===undefined) ? "-" : 
                        Number(bid.reserve).toLocaleString(auctionData.currency ==='INR' ? 'en-IN' : 'en-US', {
                            style: 'currency',
                            currency: auctionData.currency,
                            minimumFractionDigits: 0,
                            maximumFractionDigits: 0,
                        })} >
                    {(bid.reserve===0 || bid.reserve===undefined) ? "-" : 
                        Number(bid.reserve).toLocaleString(auctionData.currency ==='INR' ? 'en-IN' : 'en-US', {
                            style: 'currency',
                            currency: auctionData.currency,
                            minimumFractionDigits: 0,
                            maximumFractionDigits: 0,
                        })}
                </td>
                <td className="text-[#343434] px-5 py-3 text-[14px] leading-normal font-medium">
                    {bid.name===""  ? '-' : (bid.name.length > 20 ? bid.name.substring(0, 20) + '...' : bid.name)}
                </td>
                <td className="text-[#343434] px-5 py-3 text-[14px] leading-normal font-medium">
                    {bid.paddle_number===""  ? '-' : bid.paddle_number}
                </td>
                <td className="text-[#343434] px-5 py-3 text-[14px] leading-normal font-medium">
                    {bid.country_code} {bid.phone_number}
                </td>
                <td className="text-[#343434] px-5 py-3 text-[14px] leading-normal font-medium truncate max-w-[170px]"
                    title= {(bid.bid_amount===0 || bid.bid_amount===undefined) ? "-" : 
                        Number(bid.bid_amount).toLocaleString(auctionData.currency ==='INR' ? 'en-IN' : 'en-US', {
                            style: 'currency',
                            currency: auctionData.currency,
                            minimumFractionDigits: 0,
                            maximumFractionDigits: 0,
                        })
                    }>
                    {(bid.bid_amount===0 || bid.bid_amount===undefined) ? "-" : 
                        Number(bid.bid_amount).toLocaleString(auctionData.currency ==='INR' ? 'en-IN' : 'en-US', {
                            style: 'currency',
                            currency: auctionData.currency,
                            minimumFractionDigits: 0,
                            maximumFractionDigits: 0,
                        })
                    }
                </td>
                <td className=" sm:relative  sm:bg-transparent bg-[#fff]  sticky top-0 right-0">
                    <div className=" sm:px-4 px-2 h-fit py-[43px] sm:shadow-none shadow-bs7 ">
                        <span className="flex justify-end ">
                            <Menu as="div" className="relative" >
                                <Menu.Button>
                                    <img src="/images/three-dots-icon-black.svg" alt="img" 
                                        className="cursor-pointer three-dots-icon" type="button"
                                        id="action-lot"
                                        data-testid={`action-${bid.lot_number}`} />
                                </Menu.Button>
                                <Menu.Items>
                                    <div className="dropdown-cont absolute overflow-hidden rounded-[10px] float-left 
                                        m-0 w-[150px] py-2 px-2 min-w-max right-0 z-[50] 
                                        list-none  border-none bg-white bg-clip-padding 
                                        text-left text-base shadow-bs3 ">
                                        <Menu.Item>
                                            <button data-testid="view-bid"
                                                className="disabled:text-[hsl(240,4%,65%)] disabled:cursor-auto text-left 
                                            block w-full whitespace-nowrap bg-transparent pl-3 pr-5 py-2 text-[12px] 
                                            font-medium text-[#343434] cursor-pointer hover:bg-[#E6E6E6] hover:rounded-[11px]"
                                            >View</button>
                                        </Menu.Item>
                                        <Menu.Item>
                                            <button 
                                                disabled={auctionData.status !=='Published'}
                                                onClick={()=>setIsOpen(true)}
                                                className="block w-full whitespace-nowrap bg-transparent pl-3 pr-5 
                                                hover:bg-[#E6E6E6] hover:rounded-[11px] py-2 text-[12px] 
                                                font-medium text-[#343434] disabled:text-[hsl(240,4%,65%)] text-left"
                                                data-testid="delete-lot"
                                            >Delete</button>
                                        </Menu.Item>
                                    </div>
                                </Menu.Items>
                            </Menu>
                        </span>
                    </div>
                </td>
            </tr>
            <Modal setIsOpen={setIsOpen} isOpen={isOpen} title="Are you sure you want to delete this telephone bid?"
                buttonText="Delete" content={content} handleAction={deleteHandler} loading={loading} />
        </>
    )
}